export interface ScrollConfig {
    trigger: HTMLElement,
    to: number,
    offset?: number
}

export class Scroll {
    private readonly trigger: HTMLElement;
    protected offset: number;
    public duration: number = 400;
    public to: number;

    constructor({trigger, to, offset}: ScrollConfig) {
        this.trigger = trigger;
        this.to = to;
        this.offset = offset ? offset : null;
        this.bind();
    }

    protected toggleTrigger(): void {
        window.addEventListener(`scroll`, () => {
            pageYOffset > this.offset
                ? this.trigger.classList.add('is-active')
                : this.trigger.classList.remove('is-active');
        });
    }

    public scrollTo(evt: Event): void {
        evt.preventDefault();

        const element = document.scrollingElement || document.documentElement;
        const start = element.scrollTop;
        const change = this.to - start;
        const startDate = +new Date();

        const easeInOutQuad = (t: number, b: number, c: number, d: number): number => {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        };

        const animateScroll = (): void => {
            const currentDate = +new Date();
            const currentTime = currentDate - startDate;
            element.scrollTop = parseInt(`${easeInOutQuad(currentTime, start, change, this.duration)}`);
            if (currentTime < this.duration) {
                requestAnimationFrame(animateScroll);
            }
            else {
                element.scrollTop = this.to;
            }
        };

        animateScroll();
    }

    protected bind(): void {
        if (!this.trigger) return;
        this.trigger.addEventListener('click', (evt) => this.scrollTo(evt));
        if (this.offset) this.toggleTrigger();
    }
}